export const enum SnCameraPtzMovementType {
  RELATIVE = 'relative',
  CONTINUOUS = 'continuous',
}
